import React from 'react'
//styles
import "./ProductCard.css"

import { Image } from 'antd';
import { FaEye } from 'react-icons/fa6';
interface Props {
    name:string
    description:string
    category:string
    bcvPrice:number
    image:string
    franchise:string
    location?:string

}

const ProductCard = ({name, description, bcvPrice, image, category, franchise, location}:Props) => {
  return (
    <div className='ProductCardComponent'>
        <div className='ProductCard-image'>
            <Image 
            className='productCard-image-element' 
            src={image} 
            alt={`Producto ${name}`}
            preview={{
            mask: <FaEye />, }} 
            />
        </div>

        <div className='ProductCard-body'>
            <div className='ProductCard-text'>
                <span className='ProductCard-name'>{name}</span>
                <span className='ProductCard-detail'>{category}, {franchise}, {location}</span>
            </div>

            <div className='ProductCard-bottom'>
                <span className='productCard-price'>${bcvPrice}</span>

                {/* <FaPlus /> */}
            </div>
        </div>

    </div>
  )
}

export default ProductCard